import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormControl, FormArray, FormGroup, AbstractControl } from '@angular/forms';
import { Observable,combineLatest, throwError, merge, EMPTY ,switchMap, of} from 'rxjs';
import { map, distinct, mapTo, catchError, retry } from 'rxjs/operators';
import { Event, Partner } from '@app/shared/_models/common';
import { Product, ProductTpl,  ProductPackagingVal  } from '@app/shared/_models/product';
import * as constants from "@app/shared/constants";
import { CommonService } from '@app/common/common.service';
import { Cuf } from '@app/shared/_models/common'

import { environment } from '@app/../environments/environment';
import { LoginService } from '@app/common/login.service';
import { OffersService } from '../offers/offers.service';

// const headers = { 'content-type': 'application/json' };

@Injectable({
	providedIn: 'root'
})

export class ProductTplService {

	constructor(public loginService: LoginService, private http: HttpClient, private commonService: CommonService ) { }

	

	
	getTemplate(id: number,  cufs: Cuf[] ) : Observable<any> { // new way to do it (jpc)
		// return this.http.get<any>(environment.server_url + "/template/" + id); 
    const cufClause = cufs.map(cuf => ` AND cuf:${cuf.id}`).join('');
		return this.http.get<any>(environment.server_url + "/productstpl?q=template_id:" + id + cufClause +'&o=attributes,attach') ;
	}
	
	// getTemplateAsFormGroup(id: number) : Observable<FormGroup> {
	// 	return combineLatest ([this.getTemplate(id), this.commonService.getCufs(constants.C_COMPONENT_PRODUCT) ]  ) .pipe(map( (arrayProductTplAndCufStructure : [ ProductTpl, Cuf[] ]) =>{
	// 	// return this.getTemplate(id).pipe(map((productTpl: ProductTpl) => {
  //   console.log('arrayProductTplAndCufStructure[1]',arrayProductTplAndCufStructure[1]);
	// 		const fg = ProductTpl.asFormGroup(arrayProductTplAndCufStructure[0],arrayProductTplAndCufStructure[1]);
	// 		return fg;
	// 	}));
	// }

  getTemplateAsFormGroup(id: number): Observable<FormGroup> {  // TODO i don't like this, because we get an array of ProductTpl, but we only need the first one so we put [0] 
    return this.commonService.getCufs(constants.C_COMPONENT_TEMPLATE).pipe(
      switchMap((cufs: Cuf[]) => {
        console.log('[getTemplateAsFormGroup] CUFs:', cufs);
        console.log('[getTemplateAsFormGroup] id:', id);
        return this.getTemplate(id, cufs).pipe(
          map((productTpl: ProductTpl[]) => {
            // console.log('inside getTemplateAsFormGroup value of productTpl :',productTpl[0]);
            const fg = ProductTpl.asFormGroup(productTpl[0], cufs);
            // console.log('fg',fg.value);
            return fg;
          })
        );
      })
    );
  }



	getProduct(id: number , o: string[] = [] ) : Observable<any> {
    const cpl = o.length ? '?o=' + o.join(',') : '';
		return this.http.get<void>(environment.server_url + "/product/" + id + cpl);
	}
	
	getProductAsFormGroup(id: number , o: string[] = [] ) : Observable<FormGroup> {
		return this.getProduct(id , o ).pipe(map((product: Product) => {
			const fg = Product.asFormGroup(product);
			return fg;
		}));
	}	
	
  
// // // old not anymore used, now only ProductPackagingVal to link product to c_values.packaging
// 	getPackagingsByTemplateAsFormArray(template: any) : Observable<FormArray>{	
// 		return this.getPackagingsByTemplate(template).pipe(map((tplPackaging: TplPackaging[]) => {
// 			// console.log("template: " + JSON.stringify(productTpl));
// 			const fgs:FormArray = new FormArray( tplPackaging.map(TplPackaging.asFormGroup));
// 			return fgs;
// 		}));
// 	}
	
//   // old not anymore used, now only ProductPackagingVal to link product to c_values.packaging
//   postTplpackaging(tplPackaging:TplPackaging) {
//   	return this.http.post<any>(environment.server_url + "/tplpackaging", tplPackaging, { 'headers': constants.jsonheader });
//   }


	getPackagingsByTemplate(template: any) : Observable<any> { 
		return this.http.get<void>(environment.server_url + "/template_packagings/" + template);
	}	
	
	getPackagings() : Observable<any> { 
		return this.http.get<void>(environment.server_url + "/packagings");
	}		

	getPackagingValsAsFormArrayByProductId(product_id: any) : Observable<FormArray>{	
		return this.getPackagingValsByProductId(product_id).pipe(map((productPackagingVals: ProductPackagingVal[]) => {
			const fgs:FormArray = new FormArray( productPackagingVals.map(ProductPackagingVal.asFormGroup));
			return fgs;
		}));
	}

  getPackagingValsArrayByProductId(product: any) : Observable<ProductPackagingVal[]>{	
		return this.getPackagingValsByProductId(product).pipe(map((productPackagingVals: ProductPackagingVal[]) => {
			return  productPackagingVals.map(ProductPackagingVal.from);
		}));
	}
	
	getPackagingValsByProductId(product_id: any) : Observable<any> { 
		return this.http.get<void>(environment.server_url + "/product_packaging_vals/" + product_id);
	}
		
	postTemplate(formGroup: FormGroup): Observable<any> {
		console.log("In postTemplate, " + JSON.stringify(formGroup?.value));
		//return EMPTY;
		return this.http.post<any>(environment.server_url + "/template", formGroup.value, { 'headers': constants.jsonheader });
	}
	
  postProductEvent(eventtyp: number, objectid: number, objecttyp: number, oldData: any, newFormGroup: FormGroup): Observable<any> {
	  let old_new = {'old': oldData instanceof FormGroup ? oldData.getRawValue() : oldData, 'new':newFormGroup.getRawValue()};
	  let event:Event = {
		  id: 0,
		  typ: eventtyp,			// 1: Insert, 2: Update, 3: Delete
			userid: this.loginService.loggeduser?.id,			
		  objectid: objectid,
		  objecttyp: objecttyp,		// Product OR Template
		  data: old_new,
	  }
	  return this.http.post<any>(environment.server_url + "/event", event, { 'headers': constants.jsonheader });
  }
  
	postProduct(product: any): Observable<any> {
		return this.http.post<any>(environment.server_url + "/product", product, { 'headers': constants.jsonheader });
	}		
	
	
	// deletetTplpackaging(template:number, packaging: number) {
	// 	return this.http.delete<any>(environment.server_url + "/tplpackaging/"+ template + "/" + packaging);
	// }	
	
	postPackagingVal(productPackagingVal:ProductPackagingVal) {
		return this.http.post<any>(environment.server_url + "/packagingval", productPackagingVal, { 'headers': constants.jsonheader });
	}
	
	deletePackagingVal(id:number, packaging_id: number, product_id: number) {
		return this.http.delete<any>(environment.server_url + "/packagingval/"+ id + "/" + packaging_id + "/" + product_id);
	}	

  postAttachProductToTemplate(template_id: number, product_id : number, combinatoireAttVal : number[]): Observable<any> {
    let event:Event = {
      id: 0,
      typ: constants.EventType.TPL_SPECIFIC_A,			// 1: Insert, 2: Update, 3: Delete and a lot more...  here  EventType.TPL_SPECIFIC_A   = 500;    // Attach specific in Template 
      userid: this.loginService.loggeduser?.id,			
      objectid: product_id,
      objecttyp: constants.ObjectType.PRODUCT,		//  Template
      data: {template_id: template_id, product_id: product_id, combinatoire_att_val: combinatoireAttVal},
    }
    return this.http.post<any>(environment.server_url + "/event", event, { 'headers': constants.jsonheader });
  }


  postDetachProductFromTemplate(product_id: number): Observable<any> {
    let event:Event = {
      id: 0,
      typ: constants.EventType.TPL_SPECIFIC_D,			// 1: Insert, 2: Update, 3: Delete and a lot more...  here  EventType.TPL_SPECIFIC_D   = 501;    // Dettach specific in Template 
      userid: this.loginService.loggeduser?.id,			
      objectid: product_id,
      objecttyp: constants.ObjectType.PRODUCT,		//  Template pas très logique ici mais c'est pour que coter server attach et detach soient a cote
      data: {product_id: product_id },
    }
    return this.http.post<any>(environment.server_url + "/event", event, { 'headers': constants.jsonheader });
  }

  postAddSupplierToTemplate(supplier_id: number, template_id: number ): Observable<any> {
    if( !supplier_id || !template_id ) { return of(null); }
    let event:Event = {
      id: 0,
      typ: constants.EventType.TPL_SUPPLIER_A,			// 1: Insert, 2: Update, 3: Delete and a lot more...  here  EventType.TPL_SPECIFIC_D   = 501;    // Dettach specific in Template 
      userid: this.loginService.loggeduser?.id,			
      objectid: template_id,
      objecttyp: constants.ObjectType.TEMPLATE,		//  Template pas très logique ici mais c'est pour que coter server attach et detach soient a cote
      data: {supplier_id: supplier_id, template_id : template_id  },
    }
    return this.http.post<any>(environment.server_url + "/event", event, { 'headers': constants.jsonheader });
  }

  postRemoveSupplierToTemplate(supplier_id: number, template_id: number ): Observable<any> {
    // if( !supplier_id || !template_id ) { return of(null); }
    let event:Event = {
      id: 0,
      typ: constants.EventType.TPL_SUPPLIER_R,			// 1: Insert, 2: Update, 3: Delete and a lot more...  here  EventType.TPL_SPECIFIC_D   = 501;    // Dettach specific in Template 
      userid: this.loginService.loggeduser?.id,			
      objectid: template_id,
      objecttyp: constants.ObjectType.TEMPLATE,		//  Template pas très logique ici mais c'est pour que coter server attach et detach soient a cote
      data: {supplier_id: supplier_id, template_id : template_id  },
    }
    return this.http.post<any>(environment.server_url + "/event", event, { 'headers': constants.jsonheader });
  }

  postRemovePackagingToProduct(packagingVal_id : number , product_id:number) : Observable<any> {
    // if( !supplier_id || !template_id ) { return of(null); }
    let event:Event = {
      id: 0,
      typ: constants.EventType.PRODUCT_DEACTIVATE_PACKAGING,			// 1: Insert, 2: Update, 3: Delete and a lot more...  here  EventType.TPL_SPECIFIC_D   = 501;    // Dettach specific in Template 
      userid: this.loginService.loggeduser?.id,			
      objectid: product_id,
      objecttyp: constants.ObjectType.PRODUCT,		//  Template pas très logique ici mais c'est pour que coter server attach et detach soient a cote
      data: {packagingVal_id: packagingVal_id, product_id : product_id  },
    }
    return this.http.post<any>(environment.server_url + "/event", event, { 'headers': constants.jsonheader });
  }

}
